import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BillsService } from "../../../../injections/bills.service";

@Component({
    selector: 'header-bill',
    templateUrl: '../../templates/partials/header-bill.html'
})

export class HeaderBillComponent implements OnInit {

    @Input() paidBill;
    @Input() data;
    @Output() openModalEmitter = new EventEmitter();
    @Output() openModalBillEmitter = new EventEmitter();
    @Output() openModalDownloadEmitter = new EventEmitter();
    public buttonDowloadD = false;
    constructor(private router: Router, private billsService: BillsService) { }

    public sendBill(){
        //console.log("Send");
    }

    public downloadBill(){
        //console.log(this.data);
        this.openModalDownloadEmitter.next({action: "open", data: null});

    }

    public seeBill() {
        this.openModalBillEmitter.next({action: "open", data: this.data});
    }

    public showModalPayment(payment: number){
        this.openModalEmitter.next({action: "open", data: payment});
        //console.log("modalPayment");
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/header-bill.component.ts